import React from 'react'

import blogData from "../componets/blogData"
import { Link, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { slugify } from './validators/slugify'

export default function Blog() {
  return (
   <>
    <Helmet>
            <title>Travel & Stay Blog | V Hotel The Grand Shoba </title>

            <meta name="description" content="Read the latest travel and stay tips from V Hotel The Grand Shoba. Find hotel insights, guides near Delhi Airport, and stories to make every trip easier." />
            <meta name="keywords" content="Corporate Hall Near Delhi Airport" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://www.vhotelthegrandshoba.com/blog"/>

         </Helmet>
    <div
      className="hero-section text-white text-center d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `url(/images/blog_banner.jpg)`,
        backgroundSize: "cover",
        
        backgroundPosition: "center",
        height: "60vh",
        position: "relative",
      }}
    >
      <div
        className=" corpo-hero-card  p-4 rounded"
        style={{ maxWidth: "90%" }}
      >
        <h1 className="display-6 fw-bold text-uppercase" style={{color:"#AD8B3A"}}>Blog - Travel & Stay Blog </h1>
       
      </div>
    </div>



    <div>
  
    {
        blogData.map((item,index)=>{
            return(
              <div className="container" key={index}>
                <div className="container-fluid">
                    <div className="row " style={{ paddingTop: "75px", paddingBottom:"35px"}}>
                        <div className="col-md-8  " >
                            <div >
                                <img src={item.img} alt="Cochin Sightseeing"
                                    className=" rounded shadow-sm w-100"
                                    style={{ objectFit: "cover", }} />
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <p style={{textAlign:"justify",
                                 paddingBottom: "20px", fontSize: "28px", paddingTop:"30px", fontWeight:"bolder",  fontFamily: "Cinzel" }}>{item?.name}</p>
                            <p style={{textAlign:"justify"}}>
                              {item.description.split(" ").slice(0, 46).join(" ")}
                                {item.description.split(" ").length > 46 && "..."}
                            </p>
                            <div style={{ paddingTop:"15px"}}>
                                <Link to={`/blog/${slugify(item?.slug)}`} className='p-3 rounded' style={{backgroundColor:"#AD8B2a", color:"white", textDecoration:"none",}}>
                                Read More
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            )
        })
    }


     


    </div>
   </>
  )
}
